export const getRandomNumber = (len) => Math.floor(Math.random() * len);
